var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"services-container"},[_c('ServiceHeader'),_c('div',{style:(_vm.getSectionStyle())},[_c('span',{staticClass:"image-overlay"}),_c('ServiceCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }